import { PRIMEUR_TABS, WARN_BY_STATE } from '@/constants/primeur';
import { URLS } from '@/constants/urls';

export const getPrimeurLinksConfig = (counter) => ({
  defaults: [
    { name: PRIMEUR_TABS.SEARCH, icon: URLS.PRIMEUR_SEARCH, display: true },
    { name: PRIMEUR_TABS.ALERTS, icon: URLS.PRIMEUR_NOTIF, display: true, counter: counter },
    { name: PRIMEUR_TABS.PREFERENCES, icon: URLS.PRIMEUR_SETTING, display: true }
  ]
});

export const getAvailableAlerts = (designations, alerts) => {
  if (alerts?.length > 0) {
    return Object.values(designations).reduce(
      (previous, current) => previous.concat(current)
    ).map(
      (designation) => designation.partnumber
    ).filter(
      (partnumber) => alerts.includes(partnumber)
    );
  } else {
    return [];
  }
};

export const getWarnBy = (primeurUser) => {
  if (primeurUser) {
    if (!primeurUser.warnByEmail && primeurUser.warnBySms) {
      return WARN_BY_STATE.SMS;
    } else if (primeurUser.warnByEmail && primeurUser.warnBySms) {
      return WARN_BY_STATE.EMAILANDSMS;
    }
  }

  return WARN_BY_STATE.EMAIL;
};

export const updateWarnBy = (warnBy) => {
  if (warnBy === WARN_BY_STATE.EMAIL) {
    return [true, false];
  } else if (warnBy === WARN_BY_STATE.SMS) {
    return [false, true];
  } else {
    return [true, true];
  }
};
